function CheckAdmin() {
    return (
        localStorage.getItem("mau_user_type") === "admin" || localStorage.getItem("mau_user_type") === "dev"
            ? true
            : false
    );
}

export default CheckAdmin;
